import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/icons/three-dots-vertical.svg'


const _withScopeId = n => (_pushScopeId("data-v-01c7863a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "menu"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "d-flex justify-space-between align-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"25px","width":"fit-content"} }, "Reward Detail", -1))
const _hoisted_5 = { class: "grid-3-col" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold pr-2" }, "Campaign Name: ", -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold pr-2" }, "Processing Date:", -1))
const _hoisted_10 = { class: "d-flex justify-end" }
const _hoisted_11 = { class: "total-reward-box" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "container-reward-detail-table pt-4" }
const _hoisted_14 = { class: "table-container" }
const _hoisted_15 = { class: "reward-detail-table" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Action"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start wmx-120" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start wmx-240" }, "User Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start wmx-240" }, "Merchant Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start wmx-150" }, "Reward (THB)")
  ])
], -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  colspan: "6",
  class: "text-center py-8"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center py-8"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "Error Found")
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center py-8"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "No Data")
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "d-flex justify-end" }
const _hoisted_31 = { class: "reward-amount-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_VButton = _resolveComponent("VButton")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_menu, null, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("button", _normalizeProps(_guardReactiveProps(props)), _hoisted_2, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, { density: "compact" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ACTION_MENU, (item, index) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: index,
                value: item,
                onClick: ($event: any) => (_ctx.handleActionClick(item.actionKey))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      transition: "dialog-bottom-transition",
      width: "1040",
      modelValue: _ctx.isShowDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowDialog) = $event)),
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          "max-width": "1040",
          rounded: "lg"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_VButton, {
                    message: 'Export',
                    radius: '20px',
                    bgColor: '#fff',
                    bgBorder: '1px solid #dadbe6',
                    width: '10rem',
                    src: require('@/assets/svgs/icons/csv.svg'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DoExportExcel()))
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "border-opacity-25" }),
            _createVNode(_component_v_card_text, {
              class: "p-4",
              style: {"max-height":"700px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", {
                      class: "text-ellipsis-max-w-300",
                      title: _ctx.rewardDetail ? _ctx.rewardDetail.campaignName : ''
                    }, _toDisplayString(_ctx.rewardDetail ? _ctx.rewardDetail.campaignName : ''), 9, _hoisted_8)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.rewardDetail ? _ctx.formatDate(_ctx.rewardDetail.processingDate) : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode(" Total "),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.rewardDetail ? _ctx.addComma(_ctx.rewardDetail.totalReward || 0, { toFixed: 2 }) : '0'), 1),
                      _createTextVNode(" THB ")
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("table", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("tbody", null, [
                        (_ctx.isLoadingRewardDetail && !_ctx.isErrorLoadingRewardDetail)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                              _createElementVNode("td", _hoisted_18, [
                                _createVNode(_component_v_progress_circular, {
                                  color: "#3B3C66",
                                  indeterminate: "",
                                  width: 3,
                                  size: 25
                                })
                              ])
                            ]))
                          : (_ctx.isErrorLoadingRewardDetail && !_ctx.isLoadingRewardDetail)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
                            : (!_ctx.rewardDetail || !_ctx.rewardDetail.detailLists || _ctx.rewardDetail.detailLists.length === 0)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, _hoisted_24))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.rewardDetail.detailLists, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.merchantCode,
                                    class: "data-row"
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.firstIndexInPage + index + 1), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("p", {
                                        class: "text-start text-ellipsis-max-w-150",
                                        title: item.action
                                      }, _toDisplayString(_ctx.getActionTypeWording(item.action)), 9, _hoisted_26)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.formatDate(item.processingDate)), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("p", {
                                        class: "text-ellipsis-max-w-220",
                                        title: item.userEmail
                                      }, _toDisplayString(item.userEmail), 9, _hoisted_28)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("p", {
                                        class: "text-ellipsis-max-w-220",
                                        title: item.merchantName
                                      }, _toDisplayString(item.merchantName), 9, _hoisted_29)
                                    ]),
                                    _createElementVNode("td", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.addComma(item.rewardAmount || 0, { toFixed: 2 })), 1)
                                    ])
                                  ]))
                                }), 128))
                      ])
                    ])
                  ]),
                  _createVNode(_component_Pagination, {
                    class: "pagination",
                    justifyContent: "flex-end",
                    data: _ctx.pagination,
                    totalPage: _ctx.paginationRewardDetailList.totalPages,
                    onPage: _ctx.handlePageChange,
                    onPerPageEvent: _ctx.handleSelectPageNumber,
                    onLength: _ctx.handlePageLengthChange
                  }, null, 8, ["data", "totalPage", "onPage", "onPerPageEvent", "onLength"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "border-opacity-25" }),
            _createVNode(_component_v_card_actions, { class: "justify-end pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_VButton, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowDialog = false)),
                  message: 'Close',
                  bgBorder: '1px solid #DADBE6',
                  fontColor: '#3B3C66',
                  radius: '20px',
                  width: '10rem'
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}